import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="254.2126312" cy="150.9294281" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="229.9018097" cy="150.9295654" rx="7.4444652" ry="8.2716284" />
					<ellipse cx="278.0979919" cy="150.9295654" rx="7.4444652" ry="8.2716284" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M270.8044434,155.956665c0.1473694,0,0.2966309-0.0135345,0.4468079-0.0419769l14.5814819-2.7601471
						c1.2956543-0.2453308,2.1473083-1.494812,1.9019775-2.7904663c-0.2453308-1.2961273-1.4934082-2.1463623-2.7900085-1.9024353
						l-14.5814819,2.7601471c-1.2956543,0.2453156-2.1473083,1.494812-1.9019775,2.7904663
						C268.6776428,155.1581879,269.6794739,155.956665,270.8044434,155.956665z" />
					<path d="M237.195343,155.956665c-0.1473694,0-0.2966309-0.0135345-0.4468079-0.0419769l-14.5814819-2.7601471
						c-1.2956543-0.2453308-2.1473083-1.494812-1.9019775-2.7904663c0.2453308-1.2961273,1.4934082-2.1463623,2.7899933-1.9024353
						l14.5814972,2.7601471c1.2956543,0.2453156,2.1472931,1.494812,1.9019623,2.7904663
						C239.3221283,155.1581879,238.3202972,155.956665,237.195343,155.956665z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M237.1350403,155.9220886c-0.5759277,0-1.152771-0.2074738-1.6105194-0.6280212
						c-0.8755035-0.8038483-2.7660675-1.7133179-5.447464-1.8542633c-2.6795349-0.135849-4.6566162,0.5661316-5.6112061,1.2746277
						c-1.0578613,0.78479-2.5483398,0.5628967-3.3317413-0.4926453c-0.784317-1.0559845-0.5638123-2.5478821,0.4921875-3.3321991
						c2.1287384-1.5807343,5.2883606-2.3869324,8.700119-2.2068939c3.3996582,0.1786346,6.4690247,1.3099976,8.42099,3.1037903
						c0.9685364,0.8899231,1.0327454,2.396698,0.1423492,3.3652344
						C238.4199066,155.6629791,237.7788696,155.9220886,237.1350403,155.9220886z" />
					<path d="M270.8019409,155.9220886c0.5758972,0,1.1527405-0.2074738,1.6105042-0.6280212
						c0.8754883-0.8038483,2.7660522-1.7133179,5.4474487-1.8542633c2.6795349-0.135849,4.6566467,0.5661316,5.6112061,1.2746277
						c1.0578613,0.78479,2.5483704,0.5628967,3.3317566-0.4926453c0.7843323-1.0559845,0.5638123-2.5478821-0.4921875-3.3321991
						c-2.1287231-1.5807343-5.2883606-2.3869324-8.7001038-2.2068939c-3.3996582,0.1786346-6.4690247,1.3099976-8.42099,3.1037903
						c-0.9685669,0.8899231-1.0327454,2.396698-0.1423645,3.3652344
						C269.5170593,155.6629791,270.1581116,155.9220886,270.8019409,155.9220886z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M237.3462677,150.9295654c0,4.5682831-3.3329926,8.2716217-7.444458,8.2716217s-7.4444733-3.7033386-7.4444733-8.2716217
						c0-3.2873535,3.3330078-3.0427094,7.4444733-3.0427094S237.3462677,147.6422119,237.3462677,150.9295654z" />
					<path d="M285.54245,150.9295654c0,4.5682831-3.3330078,8.2716217-7.444458,8.2716217
						c-4.1114807,0-7.4444885-3.7033386-7.4444885-8.2716217c0-3.2873535,3.3330078-3.0427094,7.4444885-3.0427094
						C282.2094421,147.8868561,285.54245,147.6422119,285.54245,150.9295654z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/TuxedoBird/Eyes.js